import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	FormControl,
	InputLabel,
	OutlinedInput,
	FormHelperText,
	withStyles,
} from '@material-ui/core'
import { setDelay, changeDelayUnit } from 'actions/tasks'
import ReactSelect from 'components/theme/Select'
import timeUnitsInSeconds from 'utils/timeUnitsInSeconds'
import language from 'utils/vast-languagepack'

const customStyles = {
	control: (provided) => ({
		...provided,
		borderRadius: '28px',
		padding: '9px 0',
	}),
	menu: (provided) => ({
		...provided,
		zIndex: 2,
	}),
}

const styles = (theme) => ({
	textField: {
		marginLeft: theme.spacing.unit,
		marginRight: theme.spacing.unit,
	},
	notchedOutline: {
		borderRadius: 28,
		paddingLeft: '40px !important',
	},
})

export default connect(
	(state) => {
		const task = state.tasks.tasksByID[state.tasks.addOrEdit.taskID]
		const stats = task?.sms_stats || task?.email_stats
		const campaignStatus =
			state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
		const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
		const disabled = Boolean(
			(stats && automationTypeSelected !== 'stage') ||
				campaignStatus === 'L' ||
				campaignStatus === 'C',
		)

		return {
			delay: state.tasks.addOrEdit.delay,
			delayUnit: state.tasks.addOrEdit.delayUnit,
			disabled,
		}
	},
	(dispatch) => bindActionCreators({ setDelay, changeDelayUnit }, dispatch),
)(
	withStyles(styles)(
		class Delay extends Component {
			componentDidMount() {
				this.forceUpdate()
			}

			render() {
				const {
					delay,
					setDelay,
					error,
					classes,
					delayUnit,
					changeDelayUnit,
					disabled,
				} = this.props

				return disabled ? null : (
					<div style={{ position: 'relative', width: '100%' }}>
						<div
							style={{
								display: 'inline-block',
								width: '50%',
								padding: '0 8px 0 0',
							}}
						>
							<FormControl
								disabled={disabled}
								error={Boolean(error)}
								fullWidth
								variant="outlined"
							>
								<InputLabel
									ref={(ref) => {
										this.labelRef = ReactDOM.findDOMNode(ref)
									}}
									htmlFor="delay"
									shrink
									style={{ transform: 'translate(44px, -6px) scale(0.75)' }}
								>
									{language.task.add.delay}
								</InputLabel>
								<OutlinedInput
									id="delay"
									labelWidth={this.labelRef ? this.labelRef.offsetWidth : 0}
									value={delay}
									onChange={(e) => setDelay(e.target.value)}
									placeholder={'Enter a delay'}
									notched
									classes={{
										notchedOutline: classes.notchedOutline,
									}}
									type="number"
								/>
								<FormHelperText error={Boolean(error)}>
									{error
										? error
										: `Maximum: ${Math.floor(
												15552000 / timeUnitsInSeconds[delayUnit],
										  )}`}
								</FormHelperText>
							</FormControl>
						</div>
						<div
							style={{
								// display: 'inline-block',
								width: '50%',
								padding: '0 0 0 8px',
								position: 'absolute',
								bottom: 20,
								right: 0,
							}}
						>
							<ReactSelect
								styles={customStyles}
								value={{ value: delayUnit, label: delayUnit }}
								onChange={(newValue) => changeDelayUnit(newValue.value)}
								closeMenuOnSelect={false}
								options={Object.keys(timeUnitsInSeconds).map((unit) => ({
									value: unit,
									label: unit,
								}))}
								placeholder={language.task.add.helperText.timeUnits}
								isDisabled={disabled}
							/>
						</div>
					</div>
				)
			}
		},
	),
)
